export default {
  name: "focus",

  mounted(element) {
    element.querySelector("input").focus();
  },
};
